// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__UfmJq","main-header":"Homepage_main-header__zTGLs"};